"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _material = require("@mui/material");
var _MenuItemChecked = require("./MenuItemChecked");
var _SelectFilterModule = _interopRequireDefault(require("./SelectFilter.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const allOption = {
  key: "all",
  label: "All"
};
function handleAllOptionClick(onChange) {
  onChange([allOption]); //only all
}
function handleOtherOptionClick(option, currentOptions, onChange, multiple) {
  const optionIndex = currentOptions.findIndex(currentOption => currentOption.key === option.key);
  if (optionIndex !== -1) {
    //already selected.
    const newCurrentOptions = [...currentOptions];
    newCurrentOptions.splice(optionIndex, 1);
    if (!newCurrentOptions.length) {
      onChange([allOption]);
    } else {
      onChange(newCurrentOptions);
    }
  } else {
    let newCurrentOptions;
    if (!multiple) {
      newCurrentOptions = [option];
    } else {
      newCurrentOptions = currentOptions.filter(currentOption => currentOption.key !== allOption.key);
      newCurrentOptions.push(option);
    }
    onChange(newCurrentOptions);
  }
}
const SelectFilter = _ref => {
  let {
    label,
    currentOptions,
    options,
    onChange,
    multiple = true
  } = _ref;
  const [anchorEl, setAnchorEl] = _react.default.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (_, _index, option) => {
    if (option) {
      if (option.key === "all") {
        handleAllOptionClick(onChange);
      } else {
        handleOtherOptionClick(option, currentOptions, onChange, multiple);
      }
    }
    setAnchorEl(null);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectFilterModule.default["select-filter"]
  }, /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "basic-button",
    "aria-controls": open ? "basic-menu" : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? "true" : undefined,
    endIcon: /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null),
    onClick: handleClick,
    sx: {
      textTransform: "none",
      fontSize: "1rem",
      fontWeight: "400"
    }
  }, currentOptions.map(option => option.label).join(", ")), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    slotProps: {
      list: {
        "aria-labelledby": "basic-button"
      },
      paper: {
        sx: {
          boxShadow: "0 8px 8px 0 rgba(0, 0, 0, 0.08)",
          border: "1px solid",
          borderColor: "divider"
        }
      }
    },
    disablePortal: false,
    container: () => document.body,
    disableScrollLock: true
  }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    onClick: event => handleClose(event, undefined, allOption)
  }, "All"), options.length && /*#__PURE__*/_react.default.createElement(_material.Divider, null), options.map((option, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: option.key
  }, multiple ? /*#__PURE__*/_react.default.createElement(_MenuItemChecked.MenuItemChecked, {
    optionLabel: option.label,
    onClick: event => handleClose(event, undefined, option),
    checked: Boolean(currentOptions.find(currentOption => currentOption.key === option.key))
  }) : /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    key: option.key,
    onClick: event => handleClose(event, undefined, option)
  }, option.label), index < options.length - 1 && /*#__PURE__*/_react.default.createElement(_material.Divider, null)))));
};
var _default = exports.default = SelectFilter;